const theme = {
    colors: {
        primary: {
            50: "#c9d9fb",
            100: "#799ee8",
            200: "#638ee4",
            300: "#4d7ee1",
            400: "#366edd",
            500: "#205ed9",
            600: "#1d55c3",
            700: "#1a4bae",
            800: "#164298",
            900: "#133882",
        },
        neutral: {
            25: "#fafcff",
            35: "#f8fafe",
            50: "#f5f7fc",
            100: "#f5f5f5",
            110: "#f0f0f0",
            125: "#eeeeee",
            135: "#eaf1fc",
            145: "#e5eaf9",
            150: "#e5e5e5",
            200: "#dddddd",
            300: "#c4c4c4",
            350: "#bdbdbd",
            375: "#b4bbce",
            400: "#acacac",
            500: "#939393",
            550: "#818181",
            600: "#7b7b7b",
            700: "#626262",
            750: "#4B4B4B",
            800: "#494949",
            900: "#313131",
        },
        accent1: {
            100: "#eaf8f6",
            200: "#c0e9e5",
            300: "#96dbd4",
            400: "#6cccc3",
            500: "#41beb2",
            600: "#33938a",
            700: "#246963",
            800: "#163f3b",
            900: "#071514",
        },
        success: {
            100: "#e9f9f0",
            200: "#bdecd1",
            300: "#91dfb2",
            400: "#65d293",
            500: "#39c675",
            600: "#2d9a5b",
            700: "#206e41",
            800: "#134227",
            900: "#06160d",
        },
        warning: {
            100: "#fdf6e5",
            200: "#f9e4b0",
            300: "#f6d27b",
            400: "#f2c046",
            500: "#eeae11",
            600: "#b9870d",
            700: "#846009",
            800: "#4f3a06",
            900: "#1a1302",
        },
        danger: {
            100: "#fbe7e7",
            200: "#f3b6b6",
            300: "#eb8686",
            400: "#e25555",
            500: "#da2525",
            600: "#aa1d1d",
            700: "#791414",
            800: "#490c0c",
            900: "#180404",
        },
        deploymentStatus: {
            queued: "#939393",
            in_progress: "#eeae11",
            success: "#39c675",
            failure: "#e25555",
            cancelled: "#e25555",
            timed_out: "#e25555",
            action_required: "#eeae11",
            skipped: "#939393",
        } as Record<string, string>,
    },
    fontSize: {},
    fontWeight: {
        light: 400,
        normal: 500,
        bold: 600,
        bolder: 700,
    },
};

export type ThemeType = typeof theme;

export default theme;
